import { toast } from '../components/toast';

export function copyToClipboard({
	text,
	showToast = true,
}: {
	text: string;
	showToast?: boolean;
}): boolean {
	try {
		window.navigator.clipboard.writeText(text);
		if (showToast)
			toast({
				title: 'Copied to clipboard',
				variant: 'success',
			});

		return true;
	} catch (err) {
		console.error('Error copying text: ', err);
		return false;
	}
}

export function parseJsonOrFallback<T>(json: string, fallbackValue?: T): T {
	try {
		return JSON.parse(json);
	} catch (err) {
		return fallbackValue ?? (json as T);
	}
}
